(function ($) {

    var winW = $(window).width();
    var $winH = $(window).height();
    var PAGE_HEADER_ACTIVE = "menuOpen";
    var $header = $(".page-header");
    var $headerCar = $('.header-cars');
    var $mainMenu;
    var $carsMenu;
    var $headerNav;
    var $headerTopH;
    var $body = (window.opera) ? (document.compatMode == "CSS1Compat" ? $('html') : $('body')) : $('html,body');

    var loading = function () {

        var $this = {};
        $this.callback = function () {}
        $this.removeLoading = function () {
            $('.page-loading').fadeOut(function () {
                $('.page-loading').remove();

                $this.callback();
                // 動態程式寫這
                // script();

            });
        };
        $this.loadfunc = function () {
            $('html, body').imagesLoaded(function () {
                $this.removeLoading();
            });
        };
        return $this;
    };

    // var vh = window.innerHeight * 0.01;
    // document.documentElement.style.setProperty('--vh', `${vh}px`);


    function mainScript() {

        $header = $(".page-header"), $mainMenu = $(".mainMenu"), $headerNav = $(".header-nav"), $carsMenu = $(".carsMenu"), $headerCar = $('.header-cars');
        $mainMenu.on("click", function (e) {
            // e.preventDefault(), e.stopPropagation()
            $header.toggleClass(PAGE_HEADER_ACTIVE)
            if ($header.hasClass(PAGE_HEADER_ACTIVE)) {
                $headerNav.css('right', '0')
                $body.css('overflow-y', 'hidden')
            } else {
                if (winW > 480) {
                    $headerNav.css('right', '-400px');
                } else {
                    $headerNav.css('right', '-100%');
                }
                $body.css('overflow-y', 'initial')
            }

        })

        $carsMenu.on("click", function () {
            $headerCar.slideToggle();
            $headerCar.toggleClass(PAGE_HEADER_ACTIVE);
            if ($headerCar.hasClass(PAGE_HEADER_ACTIVE)) {
                $body.css('overflow-y', 'hidden')
            } else {
                $body.css('overflow-y', 'initial')
            }
        })

        $('.menuOverlay1, .header-nav .menuClose').on("click", function () {
            if ($header.hasClass(PAGE_HEADER_ACTIVE)) {
                if (winW > 480) {
                    $headerNav.css('right', '-400px');
                } else {
                    $headerNav.css('right', '-100%');
                }
                $body.css('overflow-y', 'initial')
            }
            $header.removeClass(PAGE_HEADER_ACTIVE);

        })

        $('.header-cars .menuClose, .menuOverlay2').on("click", function () {
            if ($headerCar.hasClass(PAGE_HEADER_ACTIVE)) {
                $headerCar.slideUp();
                $body.css('overflow-y', 'initial')
            }
            $headerCar.removeClass(PAGE_HEADER_ACTIVE);

        })

        $('.carCategory').on("click", function () {
            var $tab = $(this).data('tab');
            $(this).siblings('.carCategory').removeClass('active');
            $(this).addClass('active');
            $('.carList').removeClass('active');
            $('.carList' + $tab).addClass('active');
        })

        $('.carsSub').on("click", function () {
            $(this).siblings('.carsSub').removeClass('active');
            $(this).toggleClass('active');
            $(this).find('.carList_mb').slideToggle()
        })

        $('._hasSub > a').on('click', function () {
            $('.nav').addClass('out');
            $(this).siblings('.subNav').addClass('active');
        })
        $('.subNavTitle .menuPrev').on('click', function () {
            $('.nav').removeClass('out');
            $('.subNav').removeClass('active');
        })

        $(window).on("resize", navResize).resize()

    }

    $(function () {

        $(".page-header").load("includes/header.html",function(){
            // mainScript();
        });
        $(".page-footer").load("includes/footer.html"); 
        

        var imagesLoaded = loading();
        imagesLoaded.loadfunc();
        imagesLoaded.callback = function () {

            mainScript()

        };

        // $(".header-nav .navList:not(._hasSub) a, .header-nav .subNavList a").click(function () {
        //     removeNav();
        // });

        

    });


    // function windowEvents() {
    //     $(window).on("resize", navResize).resize()
    // }

    function navResize() {
        detectSize();
        //  1024 < winW ? resizePC() : resizeMB()

        if (winW <=480) {
            resizeMB()
        }else if(device.mobile() && winW <=480){
            resizeMB()
        } else if(winW > 480){
            resizePC()
        }else if(device.desktop() || device.tablet() && winW > 480){
            resizePC()
        }

        $('main').css({
            'paddingTop': $headerTopH
        })
    }

    function detectSize() {
        winW = $(window).outerWidth(), $winH = $(window).outerHeight(), $headerTopH = $(".header-top").outerHeight(), $carsMenu = $(".carsMenu"), $headerCar = $('.header-cars');
    }

    var removeNav = function () {
        $header.removeClass(PAGE_HEADER_ACTIVE);
        // $headerNav.css('right', '-100%');
        if (winW > 480) {
            $headerNav.css('right', '-400px');
        } else {
            $headerNav.css('right', '-100%');
        }
    }

    function resizePC() {
        // headerInit("block")
        // $headerCar.css("display","block");
        $carsMenu.css("display", "block");
        $('.carsSub').css("display", "none");
        // $(".header-nav").css({
        //     marginTop: 0
        // })
        // $(window).scroll(removeNav)
    }


    function resizeMB() {
        // $headerCar.css("display","none");
        $carsMenu.css("display", "none");
        $('.carsSub').css("display", "block");
        // headerInit("block");
        // $(window).scroll(removeNav)
    }

    function headerInit(e) {
        $header.removeClass(PAGE_HEADER_ACTIVE)
        $headerNav.css({
            display: e
        })
    }

})(jQuery);